<template>
  <section class="template-panel relative">
    <aha-accordion>
      <aha-accordion-item
        :on-toggle="changeUserSettings"
        :default-expanded="!rememberToHideTemplate"
        :has-default-styling="false"
        :has-bottom-border="false"
      >
        <template slot="title">
          <div class="flex mr-2">
            <h5 class="text-base font-bold">
              {{ $i18nPresenter.t("Start from a template") }}
            </h5>
          </div>
        </template>
        <template slot="content">
          <div
            v-if="isLoadingTemplatePanel"
            class="flex items-center justify-center"
          >
            <Loading />
          </div>
          <div v-else>
            <div
              class="flex mt-4"
              v-if="!templatesError && templatePanel && templatePanel.length"
            >
              <!-- create from blank -->
              <TemplateCardBasic
                class="template-panel__card-item"
                :presentation="{
                  name: term_Blank,
                }"
                :custom-handler="handleCreateBlank"
              >
                <template slot="thumbnail">
                  <div class="template-thumbnail bg-base-0 border-primary-90 border-0.5">
                    <aha-icon
                      class="text-primary-100"
                      name="add"
                      viewBox="0 0 24 24"
                    />
                  </div>
                </template>
              </TemplateCardBasic>
              <!-- responsive template containers -->
              <div
                class="template-panel__cards-container"
              >
                <div
                  v-for="template in topTemplates"
                  :key="template.id"
                >
                  <TemplateCardBasic
                    size="sm"
                    class="template-panel__card-item"
                    :presentation="template"
                    templateLocation="top panel"
                  />
                </div>
              </div>
              <!-- browse all template -->
              <TemplateCardBasic
                class="template-panel__card-item"
                :class="{'pointer-events-none' : isLoadingBrowerAll}"
                :presentation="{
                  name: term_BrowseAll
                }"
                :custom-handler="handleBrowseAllClick"
              >
                <template slot="thumbnail">
                  <div
                    class="template-thumbnail"
                  >
                    <img
                      class="object-cover w-full h-full rounded"
                      :src="require('@/assets/images/browseall.svg')"
                      alt="Thumbnail default"
                    />
                    <div class="browser__hover"></div>
                    <div
                      v-show="isLoadingBrowerAll"
                      :class="{'brower__loading': isLoadingBrowerAll}"
                    >
                      <aha-spinner
                        variant="white"
                        size="md"
                      />
                    </div>
                  </div>
                </template>
              </TemplateCardBasic>
            </div>
            <template-not-found v-else />
          </div>
        </template>
      </aha-accordion-item>
    </aha-accordion>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Loading from '@/components/Loading'
import EventBus from '@/eventBus'
import TemplateCardBasic from './TemplateCardBasic.vue'
import TemplateNotFound from './TemplateNotFound.vue'
import Config from '@/config'
import Utils from '@/util'
import constants from '@/constant'

export default {
  components: {
    TemplateCardBasic,
    Loading,
    TemplateNotFound,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoadingBrowerAll: false,
    }
  },
  computed: {
    ...mapGetters('presentationTemplates', [
      'templatePanel',
      'topTemplates',
      'isLoadingTemplatePanel',
      'templatesError',
    ]),
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    rememberToHideTemplate() {
      return this.currentUser.rememberSettings
        && this.currentUser.rememberSettings.isHideTemplatePanel
    },
    term_BrowseAll() {
      return this.$i18nPresenter.t('Browse all')
    },
    term_Blank() {
      return this.$i18nPresenter.t('Blank')
    },
  },
  mounted() {
    this.getTemplatesAction()
  },
  methods: {
    ...mapActions('presentationTemplates', ['getTemplatesAction']),
    handleBrowseAllClick() {
      this.isLoadingBrowerAll = true
      Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'Presentation list > Browse all template')
      setTimeout(() => {
        this.$router.push('/apps/template-library?from=templatePanel')
      }, 1500)
    },
    handleCreateBlank() {
      EventBus.$emit('my-presentations:create-new-presentation', {
        trigger: 'Blank from Template panel',
      })
    },
    async changeUserSettings(isAccordionVisible) {
      await this.$http.put(
        Config.api.updateUserSettings, { isHideTemplatePanel: !isAccordionVisible },
      )
      Utils.mixpanelTracking(
        constants.eventCategories.PRESENTATION_LIST,
        `Template Panel > ${isAccordionVisible ? 'Un-collapse' : 'Collapse'}`,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.template-panel {
  background-color: #F9FBFF;
}
.template-panel__cards-container  {
  @apply flex flex-wrap overflow-hidden justify-evenly;
  // allow 2 lines of title
  max-height: 115px; //https://ahaslides.atlassian.net/browse/AHA-7693
}
.template-panel__card-item {
  @apply mr-8 mb-6;
}
.template-thumbnail {
  &:hover {
    .template-thumbnail {
      @apply shadow-card border-primary-90;
    }
    .browser__hover {
      @apply opacity-100;
    }
  }
  .browser__hover {
    @apply rounded absolute top-0 left-0 w-full h-full flex opacity-0;
    @apply justify-center items-center transition-opacity border border-primary-90;
    border-width: 2px;
  }
  .brower__loading {
    @apply rounded absolute top-0 left-0 w-full h-full flex bg-primary-80 opacity-50;
    @apply justify-center items-center transition-opacity border border-primary-90;
    border-width: 2px;
  }
}
</style>
